const observerMap = new Map();

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;

    const callback = observerMap.get(entry.target);

    callback?.(entry.target);
    observerMap.delete(entry.target);
    observer.unobserve(entry.target);
  })
});

function observeElement(element, callback) {
  observerMap.set(element, callback);
  observer.observe(element);
}

function handleAnimate(el) {
  el.classList.add("visible");
}

document.addEventListener("DOMContentLoaded", async () => {
  const adSentinel = document.getElementById("dialog-sentinel");

  if(adSentinel) {
    const isBlocked = await checkAdBlock();
    if(isBlocked) {
      observeElement(adSentinel, () => {
        const overlay = document.getElementById("overlay");
        const modal = document.getElementById("ad-modal");

        overlay.setAttribute('data-state', 'open');
        modal.setAttribute('data-state', 'open');
      });
    }
  }

  const closeAdBtn = document.getElementById("close-ad-modal");

  if(closeAdBtn) {
    closeAdBtn.addEventListener("click", function () {
      const overlay = document.getElementById("overlay");
      const modal = document.getElementById("ad-modal");

      overlay.setAttribute('data-state', 'closed');
      modal.setAttribute('data-state', 'closed');
    });
  }

  const viewportHeight = window.innerHeight;
  const animatedElements = document.querySelectorAll(".animated");
  animatedElements.forEach((el) => {
    const rect = el.getBoundingClientRect();
    const isOutOfViewport = rect.top > viewportHeight;

    if(isOutOfViewport) {
      observeElement(el, handleAnimate);
      return;
    }

    el.classList.add("no-anim");
  });

  initializeGoogleTag();
});

async function checkAdBlock() {
  const bait = createBaitEl();
  const baitBlocked = checkBaitEl(bait);
  const requestBlocked = await checkRequest();

  if(baitBlocked || requestBlocked) return true;
  return false;
}

function createBaitEl() {
  const baitEl = document.createElement('div');
  baitEl.className = "adsbox ad-banner ad-unit google-ad";
  baitEl.style.cssText = "width:1px;height:1px;position:absolute;left:-9999px;top:-9999px;";
  document.body.appendChild(baitEl);
  return baitEl;
}

function checkBaitEl(bait) {
  if (!bait || bait.offsetParent === null || bait.offsetHeight === 0 || bait.offsetWidth === 0) {
      return true;
    }
    return false;
}

async function checkRequest() {
  try {
    await fetch('https://www.googletagmanager.com/gtag', { mode: 'no-cors' });
    return false;
  } catch(error) {
    return true;
  }
}

function initializeGoogleTag() {
  window.googletag = window.googletag || { cmd: [] };

  googletag.cmd.push(function () {
    const slots = document.querySelectorAll('.ad-slot');

    slots.forEach(el => {
      const adUnit = el.dataset.adUnit;
      const sizes = JSON.parse(el.dataset.sizes);

      googletag
        .defineSlot(adUnit, sizes, el.id)
        .addService(googletag.pubads());
    });

    googletag.pubads().enableLazyLoad({
      fetchMarginPercent: 200,
      renderMarginPercent: 100
    });

    googletag.enableServices();

    slots.forEach(el => {
      googletag.display(el.id);
    });
  })
}

function sharePost() {
  if(navigator.share) {
    navigator.share({
      title: document.title,
      text: 'Veja este conteúdo',
      url: window.location.href
    });
  }
}